import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LetterReadTableService } from '@schoolbelle/api/letter-read';
import { LoadingService } from '@schoolbelle/common/loading';

import { Letter } from '@schoolbelle/api/letter';
import { take, share, switchMap } from 'rxjs/operators';
import { ReadListModalComponent } from './read-list-modal.component';


@Injectable({
  providedIn:'root',
})
export class ReadListModalService {
  constructor(
    protected modal: BsModalService,
    protected loading: LoadingService,
    protected letterReadTable: LetterReadTableService,
  ){
  }
  prepare (letter:Letter & {letter_id:number}) {
    return this.letterReadTable.checkIn(
      letter, 
    ).pipe(share());
  }
  protected show () {
    const modal:BsModalRef = this.modal.show(ReadListModalComponent, {class:'modal-lg', initialState:{
      letter:this.letterReadTable.letter,
      rows:this.letterReadTable.readTableRows,
    }});
    return modal.content.action.pipe(take(1))    
  }
  open(letter:Letter & {letter_id:number}) {
    const ob = this.prepare(letter);
    this.loading.open({busy:ob.subscribe(), message:'Fetching information...'});
    return ob.pipe(switchMap(()=>{
      return this.show();
    }));
  }
}